import { LessonType } from '../../shared/types/lesson-type';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { StudyBundleCourseStatusType } from '../../shared/types/StudyBundleCourseStatusType';

export default abstract class MiniLessonsCalculations {
  static completedLessons(lessons: ReadonlyArray<StudyBundleCourseDto> = []): number {
    return lessons ? lessons.filter((lesson) => lesson.status === StudyBundleCourseStatusType.COMPLETE).length : 0;
  }

  static completedLessonsPercentage(lessons: ReadonlyArray<StudyBundleCourseDto> = []): number {
    return lessons.length === 0
      ? 0
      : Math.floor((MiniLessonsCalculations.completedLessons(lessons) / lessons.length) * 100);
  }

  static lessonsWithoutAssessment(lessons: ReadonlyArray<StudyBundleCourseDto> = []) {
    return lessons.filter((lesson) => lesson.type === LessonType.LESSON);
  }

  static completedLessonsWithoutAssessment(lessons: ReadonlyArray<StudyBundleCourseDto> = []) {
    return MiniLessonsCalculations.completedLessons(MiniLessonsCalculations.lessonsWithoutAssessment(lessons));
  }

  static areAllLessonsCompleted(lessons: ReadonlyArray<StudyBundleCourseDto>) {
    if (!lessons) {
      return false;
    }
    return MiniLessonsCalculations.completedLessons(lessons) >= lessons.length;
  }

  static currentUnitNumber(taken: number, required: number): number {
    return taken < required ? taken + 1 : taken;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lessons-calculations.ts